
export const awsConfig = {
  Auth: {
    userPoolId: 'eu-west-1_ApL3VjMkS',
    region: 'eu-west-1',
    userPoolWebClientId: '1omupmd28scv1bevlur4g9cniu',
  }
}